module.exports = __webpack_public_path__ + "static/media/digging.4eb077da.gif";